import { useQuery } from '@tanstack/react-query';
import { getCountryRiskRuns } from '../api/client';
import { bandKindOf } from '../lib/riskText';

/** Which model family serves the public map right now, read from the 244-byte
 * country_runs.json (not the 2.6 MB country.json). The informative pages key
 * their tense on it: before the switch the rebuilt model is "em sombra", after
 * it the legacy model is "a série fechada". Unknown (loading, error) reads as
 * legacy, which is the truthful default until the switch. */
export function useServedModel() {
  const q = useQuery({
    queryKey: ['countryRiskRuns'],
    queryFn: getCountryRiskRuns,
    staleTime: 60 * 60 * 1000,
    retry: 1,
  });
  const runs = q.data ?? [];
  const latest = runs[0] ?? null;
  const version = latest?.model_run_id ?? null;
  const rebuiltServed = bandKindOf(version) === 'share';
  return { version, rebuiltServed, loaded: q.isSuccess };
}
